import { Component } from '@theme/component';

const CHAR_MAP = {
  ş: 's', ğ: 'g', ı: 'i', ç: 'c', ö: 'o', ü: 'u',
  Ş: 's', Ğ: 'g', İ: 'i', I: 'i', Ç: 'c', Ö: 'o', Ü: 'u',
};

function slugify(text, usedSlugs) {
  const base = (text || '')
    .split('')
    .map((char) => CHAR_MAP[char] ?? char)
    .join('')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '') || 'baslik';

  let slug = base;
  let suffix = 2;
  while (usedSlugs.has(slug)) {
    slug = `${base}-${suffix}`;
    suffix += 1;
  }
  usedSlugs.add(slug);
  return slug;
}

class BlogPostTOC extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#build();
  }

  #build() {
    const content = document.querySelector('.blog-post-content');
    const list = this.refs.tocList;
    if (!content || !list) {
      this.hidden = true;
      return;
    }

    const includeH3 = this.dataset.includeH3 === 'true';
    const headings = Array.from(content.querySelectorAll(includeH3 ? 'h2, h3' : 'h2'));
    const minHeadings = Number(this.dataset.minHeadings) || 3;

    if (headings.length < minHeadings) {
      this.hidden = true;
      return;
    }

    const usedSlugs = new Set();
    let currentTopItem = null;

    headings.forEach((heading) => {
      if (heading.id) {
        usedSlugs.add(heading.id);
      } else {
        heading.id = slugify(heading.textContent ?? '', usedSlugs);
      }

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.appendChild(link);

      if (heading.tagName === 'H2' || !currentTopItem) {
        list.appendChild(item);
        currentTopItem = item;
        return;
      }

      let subList = currentTopItem.querySelector(':scope > ol');
      if (!subList) {
        subList = document.createElement('ol');
        subList.className = 'blog-post-toc__sublist';
        currentTopItem.appendChild(subList);
      }
      subList.appendChild(item);
    });
  }
}

if (!customElements.get('blog-post-toc')) {
  customElements.define('blog-post-toc', BlogPostTOC);
}